import { render, staticRenderFns } from "./SecurityDetector.vue?vue&type=template&id=80829502"
import script from "./SecurityDetector.vue?vue&type=script&lang=js"
export * from "./SecurityDetector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports